import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function verifyPassword(inputPassword) {
  try {
    const { data, error } = await supabase
      .from("access_codes")
      .select("organization, password_hash")
      .eq("password_hash", inputPassword) // Direct comparison for existing entries
      .eq("is_active", true);

    if (error) throw error;

    if (data && data.length > 0) {
      return { organization: data[0].organization };
    }

    return null;
  } catch (error) {
    console.error("Verification error:", error);
    return null;
  }
}

export async function logAccess(organization, ipAddress, userAgent) {
  try {
    await supabase.from("access_logs").insert({
      organization,
      ip_address: ipAddress,
      user_agent: userAgent,
    });
  } catch (error) {
    console.error("Access logging error:", error);
  }
}